import React, { useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { Button, Box } from "@mui/material";
import MyProjects from "./Projects/MyProjects";
import AdminProjects from "./Projects/AdminProjects";
import { startTour } from "../../../redux/globalJoyrideSlice";
import { myProjectsTourSteps } from "../../../tour/teacherPlanerTourSteps"

const ProjectNav = () => {
  const [activeTab, setActiveTab] = useState("all");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      startTour({
        activeTour: "project-tour",
        steps: myProjectsTourSteps(),
      })
    );
  }, [dispatch]);

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2, marginLeft: 6 }}>
        <Button
          variant={activeTab === "all" ? "contained" : "outlined"}
          onClick={() => setActiveTab("all")}
        >
          All Projects
        </Button>
        <Button
        data-tour="projects-tab-my"
          variant={activeTab === "my" ? "contained" : "outlined"}
          onClick={() => setActiveTab("my")}
        >
          My Projects
        </Button>
      </Box>

      <Box>
        {activeTab === "all" && <AdminProjects />}
        {activeTab === "my" && <MyProjects />}
      </Box>
    </Box>
  );
};

export default ProjectNav;
